import { render, staticRenderFns } from "./moreInfo.vue?vue&type=template&id=1b502014&scoped=true"
import script from "./moreInfo.vue?vue&type=script&lang=js"
export * from "./moreInfo.vue?vue&type=script&lang=js"
import style0 from "./moreInfo.vue?vue&type=style&index=0&id=1b502014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b502014",
  null
  
)

export default component.exports